import React from "react";
import "./HomeSec6.css";

const HomeSec6 = () => {
  return (
    <div className="container-main6">
      <img className="surya" src="./SURYA 1 (1).png" alt="hhh" />

      <div className="container overlay-text ">
        <div className="row">
          <div className="col-12 mm-text d-flex justify-content-center">
            <img className="text-image1" src="./image 512.webp" alt="hhh" />
            <p className="text-center lobby_text">Lobby</p>
          </div>
        </div>
        <div className="row">
          <div className="col-6 mm-text1">
            <img className="text-image1" src="./image 512.webp" alt="hhh" />
            <p className="text-2">Banquet</p>
          </div>
          <div className="mm-text1">
            <p className="text-3">Hall</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mm-text2 d-flex justify-content-center">
            <p className="text-4">Terrace</p>
            <p className="text-5">Pool</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mm-text3 d-flex">
            <p className="text-6">Rooms</p>
            <p className="text-7">Hall</p>
            <p className="text-8">Spa</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mm-text4 d-flex">
            <p className="text-9">Bathroom</p>
            <p className="text-10">Spa</p>
            <p className="text-11">Lounge</p>
          </div>
        </div>
        <div className="row">
          <div className="col-12 mm-text5 d-flex">
            <p className="text-12">Lounge</p>
            <p className="text-13">Restaurant</p>
            <p className="text-14">Reception</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeSec6;
